<div style="padding-left: 3em;">      
    <div class="top-container">
        <ng-container *ngIf="nlsToken$ | async as nls">  
                <button mat-raised-button color="primary" (click)="generateNewNLSToken()">
                    Generate NLS Token
                </button>
        </ng-container>
    </div>
    <div style="width: 70%;">
        <h5>NLS Active User Sessions</h5>
        <table mat-table [dataSource]="dataSource" class="flat-table">
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
        </ng-container>

        <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef> Username </th>
            <td mat-cell *matCellDef="let element"> {{element.username}} </td>
        </ng-container>

        <ng-container matColumnDef="loginDate">
            <th mat-header-cell *matHeaderCellDef> Login Date </th>
            <td mat-cell *matCellDef="let element"> {{element.login_date}} </td>
        </ng-container>

        <ng-container matColumnDef="loginAddress">
            <th mat-header-cell *matHeaderCellDef> Login Address </th>
            <td mat-cell *matCellDef="let element"> {{element.login_address}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">
                <mat-select [(ngModel)]="element.status" (selectionChange)="onDisconnect(element)" >                    
                    <mat-select-trigger>
                        <span [style.color]="getStatusColor(element.status)" style="font-weight: bold;">
                        {{ element.status }}
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let status of statuses" [value]="status.value" [disabled]="status.isDisabled || element.status === 'In progress'">
                        {{ status.label }}
                    </mat-option>
                </mat-select>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'row-disabled': row.signonid === 'TfREST8709'}"></tr>
        </table>
    </div>
</div>
